"use strict";

var _ = require("underscore");
var cx = require("classnames");
var UserAvatar = require("app/shared/components/User/user-avatar");
var KeyNavigator = require("app/shared/components/KeyNavigator/key-navigator");
var BooleanInput = require("app/shared/components/BooleanInput/boolean-input");
var lockScroll = require("app/util/browser/scroll");
var InputText = require("app/shared/components/InputText/input-text");
var TruncateText = require("app/shared/components/Truncate/truncate-text");

var navigateKeys = {
  UP: 38,
  DOWN: 40,
  ENTER: 13,
  ESC: 27,
  ALL_KEYS: [38, 40, 13, 27]
};

var UserSelector = React.createClass({
  mixins: [ReactIntl.IntlMixin],
  propTypes: {
    users: React.PropTypes.arrayOf(React.PropTypes.object).isRequired,
    onSelectChange: React.PropTypes.func.isRequired,
    selectionType: React.PropTypes.oneOf(["checkbox", "radioButton"]),
    border: React.PropTypes.oneOf(["thin", "thick"]),
    color: React.PropTypes.oneOf(["green", "blue", "grey"]),
    className: React.PropTypes.string,
    forceState: React.PropTypes.bool
  },
  getInitialState: function() {
    return {
      focusIndex: -1,
      focusId: null
    };
  },
  getDefaultProps: function() {
    return { selectionType: "checkbox" };
  },
  handleOnFocus: function(focusIndex, user) {
    this.setState({
      focusIndex: focusIndex,
      focusId: user.id
    });
  },
  handleCancelSelection: function(user) {
    var users = this.uncheckUser(this.props.users, user);
    this.props.onSelectChange(users);
  },
  handleConfirmSelection: function(user) {
    var users;
    if(this.props.selectionType == "checkbox") {
      users = this.handleCheckBox(user.id);
    } else {
      users = this.handleRadioButton(user.id, this.props.forceState);
    }
    this.props.onSelectChange(users);
  },
  handleCheckBox: function(itemId, forceState) {
    var users = this.props.users;
    var user = _.find(users, function(user) {
      return user.id == itemId;
    });

    if(user) {
      user = this.checkUser(user, forceState);
    }
    return users;
  },
  handleRadioButton: function(itemId, forceState) {
    var users = _.map(this.props.users, function(user) {
      if(user.id !== itemId) {
        user.checked = false;
      } else {
        user = this.checkUser(user, forceState);
      }
      return user;
    }.bind(this));

    return users;
  },
  checkUser: function(user, forceState) {
    if(forceState !== undefined) {
      user.checked = forceState;
    } else {
      user.checked = !user.checked;
    }
    return user;
  },
  uncheckUser: function(users, userToBeUnchecked) {
    return _.map(users, function (user) {
      if (user.id === userToBeUnchecked.id) {
        user.checked = false;
      }
      return user;
    });
  },
  render: function() {
    var className = cx("userSelector", this.props.className);
    return (
      <div className={className}>
        <UserSelectorInput focusIndex={this.state.focusIndex}
                            users={this.props.users}
                            onSearch={this.props.onSelectChange}
                            onFocusChange={this.handleOnFocus}
                            onConfirmSelection={this.handleConfirmSelection}
                            onCancelSelection={this.handleCancelSelection} />
        <UserSelectorList users={this.props.users}
                          onItemSelected={this.handleConfirmSelection}
                          focusId={this.state.focusId}
                          selectionType={this.props.selectionType}
                          color={this.props.color}
                          border={this.props.border} />
      </div>
    );
  }
});

function loadUsersVisibility(users, inputValue) {
  if (inputValue) {
    inputValue = inputValue.toLowerCase();
    return _.map(users, function(user) {
      user.display = shouldBeVisible(user);
      return user;
    });
  } else {
    return _.map(users, function(user) {
      user.display = true;
      return user;
    });
  }

  function shouldBeVisible(user) {
    var matchOnName, matchOnPosition = false;
    if (user.name) {
      matchOnName = (user.name.toLowerCase().indexOf(inputValue) != -1);
    }
    if (user.position) {
      matchOnPosition = (user.position.toLowerCase().indexOf(inputValue) != -1);
    }

    return (matchOnName || matchOnPosition);
  }
}

var UserSelectorInput = React.createClass({
  mixins: [ReactIntl.IntlMixin],
  propTypes: {
    users: React.PropTypes.arrayOf(React.PropTypes.object).isRequired,
    onConfirmSelection: React.PropTypes.func.isRequired,
    onCancelSelection: React.PropTypes.func.isRequired,
    onFocusChange: React.PropTypes.func.isRequired,
    focusIndex: React.PropTypes.number.isRequired
  },
  handleSearch: function(e) {
    if(navigateKeys.ALL_KEYS.indexOf(e.keyCode) !== -1) {
      e.preventDefault();
    } else {
      var inputValue = e.target.value;
      var userList = loadUsersVisibility(this.props.users, inputValue);

      this.props.onSearch(userList);
      this.resetFocus();
    }
  },
  getShownUsers: function(list) {
    return _.filter(list, function(user) {
      return user.display !== false;
    });
  },
  resetFocus: function() {
    this.props.onFocusChange(-1, {});
  },
  render: function() {
    var searchText = this.getIntlMessage("shared_components.user_selector.search");
    return (
      <div className="mb-10">
        <KeyNavigator list={this.getShownUsers(this.props.users)}
                      focusIndex={this.props.focusIndex}
                      onNavigate={this.props.onFocusChange}
                      onEnterPressed={this.props.onConfirmSelection}
                      onEscPressed={this.props.onCancelSelection}>
          <InputText placeholder={searchText} value={this.props.teamName} onChange={this.handleSearch}/>
        </KeyNavigator>
      </div>
    );
  }
});

var UserSelectorList = React.createClass({
  mixins: [ReactIntl.IntlMixin],
  propTypes: {
    users: React.PropTypes.arrayOf(React.PropTypes.object).isRequired,
    onItemSelected: React.PropTypes.func.isRequired,
    focusId: React.PropTypes.number,
    selectionType: React.PropTypes.oneOf(["checkbox", "radioButton"]),
    border: React.PropTypes.oneOf(["thin", "thick"]),
    color: React.PropTypes.oneOf(["green", "blue", "grey"])
  },
  componentDidMount: function() {
    this._userSelectorList.addEventListener("wheel", this.handleScroll);
  },
  componentWillUnmount: function() {
    this._userSelectorList.removeEventListener("wheel", this.handleScroll);
  },
  handleScroll: function(e) {
    return lockScroll(this._userSelectorList, e);
  },
  showUsers: function() {
    if (typeof this.props.users == "undefined") {
      var loading = this.getIntlMessage("shared_components.user_selector.loading");
      return <em>{loading}</em>;
    } else {
      var users = this.createSelectorItems(this.props.users);
      if (users.length === 0) {
        var noUser = this.getIntlMessage("shared_components.user_selector.no_user");
        users = <em>{noUser}</em>;
      }

      return users;
    }
  },
  createSelectorItems: function(userList) {
    var users = [];
    _.each(userList, function(user, i) {
      if(user.display === true || user.display === undefined) {
        var additionalClass = (user.id === this.props.focusId) ? "focus" : null;
        var props = {
          item: user,
          checked: user.checked,
          classNames: additionalClass,
          onClick: this.props.onItemSelected,
          selectionType: this.props.selectionType,
          color: this.props.color,
          border: this.props.border
        };

        users.push(<UserSelectorItem key={i} {...props} />);
      }
    }.bind(this));

    return users;
  },
  render: function() {
    return (
      <ul className="userSelector-list"
        ref={(userSelectorList) => this._userSelectorList = userSelectorList} >
        { this.showUsers() }
      </ul>
    );
  }
});

var UserSelectorItem = React.createClass({
  propTypes: {
    item: React.PropTypes.object.isRequired,
    checked: React.PropTypes.bool,
    onClick: React.PropTypes.func,
    selectionType: React.PropTypes.oneOf(["checkbox", "radioButton"]),
    border: React.PropTypes.oneOf(["thin", "thick"]),
    color: React.PropTypes.oneOf(["green", "blue", "grey"]),
    classNames: React.PropTypes.string
  },
  handleClick: function() {
    if(typeof this.props.onClick === "function") {
      this.props.onClick(this.props.item);
    }
  },
  getUserInfo: function(user) {
    var avatarURL;
    if(!user.avatar) {
      avatarURL = (user.avatar && user.avatar["70x70"]) ? user.avatar["70x70"] : null;
    }
    return (
      <div>
        <UserAvatar
          size="small"
          name={user.name}
          avatarURL={avatarURL}
          key={user.id}
          className="d-ib va-mid" />
        <div className="d-ib va-mid fs-14">
          <div className="d-ib va-mid userSelector-userName maxw-130">
            <TruncateText text={user.name} className="fs-14" maxWidth="110" />
          </div>
          <div className="d-ib va-mid userSelector-userJob">
            {
              user.active
              ? null
              : <TruncateText text="(inativo)" maxWidth="70" />
            }
          </div>
        </div>
      </div>
    );
  },
  render: function() {
    return (
      <li className={this.props.classNames + " selector-item ta-l mb-0"}
        onClick={this.handleClick}>
        <div className="d-ib">
          {this.getUserInfo(this.props.item)}
        </div>
        <div className="f-r mt-8">
          <BooleanInput
            type={this.props.selectionType}
            color={this.props.color}
            border={this.props.border}
            checked={this.props.checked} />
        </div>
      </li>
    );
  }
});

module.exports = UserSelector;



// WEBPACK FOOTER //
// ./app/shared/components/UserSelector/user-selector.jsx